export default __webpack_public_path__ + "static/media/equipments.4e28b53f.svg";